import * as React from "react";
import { DialogManagerDOM } from "../dialog/DialogManagerDOM";
import { ErrorDialogManagerDOM } from "../dialog/ErrorDialogManagerDOM";
import { DialogErrorDOM } from "../errors/DialogErrorDOM";
import { MenuManagerDOM } from "../menus/MenuManagerDOM";
import { TransparentDialogManagerDOM } from "../transparent-dialog/TransparentDialogManagerDOM";
import { ErrorBoundaryModal } from "./ErrorBoundaryModal";
import { TypeModal } from "./TypeModal";
export var ModalManager = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(ErrorBoundaryModal, { modalType: TypeModal.Menu },
            React.createElement(MenuManagerDOM, null)),
        React.createElement(ErrorBoundaryModal, { modalType: TypeModal.TransparentDialog },
            React.createElement(TransparentDialogManagerDOM, null)),
        React.createElement(ErrorBoundaryModal, { modalType: TypeModal.Dialog },
            React.createElement(DialogManagerDOM, null)),
        React.createElement(ErrorBoundaryModal, { modalType: TypeModal.ErrorDialog },
            React.createElement(ErrorDialogManagerDOM, null)),
        React.createElement(DialogErrorDOM, null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/modals/ModalManager.tsx
// module id = 1121
// module chunks = 3